import {
  MDBDatatable,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBSelect,
} from "mdb-react-ui-kit";
import React, { useState, useEffect } from "react";

import {
  getMisc,
  updateBillingGroups,
} from "../../../apiclients/streamsapi_bridge";
import { useFieldArray } from "react-hook-form";

export default function AvailableSeats({
  register,
  watch,
  errors,
  setValue,
  control,
  reset,
  availableSeats,
  invoice,
  bgroupName,
  billinggroupid,
  setSuccessMessage,
}) {
  const [serviceIdList, setServiceIdList] = useState([]);
  const [servicePlanList, setservicePlanList] = useState([]);

  const [serviceObj, setServiceObj] = useState({});

  const [groupId, setgroupId] = useState([]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [modalType, setModalType] = useState("delete"); // 'delete' | 'acd_warning' | 'last_seat_warning' | 'restrict_delete_warning'
  const [quantityOptions, setquantityOptions] = useState([]);
  const [deleteRestrictMessage, setdeleteRestrictMessage] = useState("");

  const toggleDeleteModal = (seat, type = "delete") => {
    setSelectedSeat(seat);
    setModalType(type);
    setDeleteModal(!deleteModal);
    if (!deleteModal) {
      setQuantity(1);
    }
  };

  const showLastSeatWarning = () => {
    setModalType("last_seat_warning");
    setDeleteModal(true);
  };

  const showACDWarning = () => {
    setModalType("acd_warning");
    setDeleteModal(true);
  };

  const handleDeleteQuantity = (seat) => {
    handleDelete(0, seat);
  };

  // const showDeleteModal = (seat) => {
  //   setModalType("delete");
  //   setSelectedSeat(seat);
  //   setQuantity(1);
  //   if (seat && seat.freeseats) {
  //     const options = Array.from({ length: seat.freeseats }, (_, i) => ({
  //       text: (i + 1).toString(),
  //       value: i + 1,
  //     }));
  //     setquantityOptions(options);
  //   } else {
  //     setquantityOptions([]);
  //   }
  //   setDeleteModal(true);
  // };

  const handleDelete = async (flag, seat) => {
    setDeleteModal(false);
    let update = {
      reqid: 130,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      bgrp_id: billinggroupid,
      delete_unused_seats: {
        quantity: flag === 1 ? quantity : seat.freeseats,
        serviceid: seat?.serviceid ?? selectedSeat?.serviceid,
      },
    };
    console.log("modified data for billing edit :::" + JSON.stringify(update));
    console.log(JSON.stringify(update));
    let saverep = await updateBillingGroups(update, flag);
    console.log(saverep);
    console.log(`reponse of billing edit :::: ${JSON.stringify(saverep)}`);
    let saverepMsg = await saverep.json();
    console.log("response of modified data :::" + JSON.stringify(saverepMsg));
    if (saverepMsg.status && saverepMsg.status == "success") {
      setSuccessMessage(saverepMsg.message);
      const currentSeats = watch("available_seats");

      const updatedSeats = currentSeats.map((seat) => {
        if (seat.serviceid === selectedSeat.serviceid) {
          return {
            ...seat,
            freeseats: Math.max(0, (seat.freeseats || 0) - quantity),
            totalseats: Math.max(0, (seat.totalseats || 0) - quantity),
            freeseatsList: Array.from(
              { length: Math.max(0, (seat.freeseats || 0) - quantity) },
              (_, i) => i + 1
            ),
          };
        }
        return seat;
      });
      setValue("available_seats", updatedSeats, { shouldDirty: false });
    } else {
      if (saverepMsg.seats_info && saverepMsg.seats_info.quantity) {
        setModalType("delete");
        setSelectedSeat(seat);
        setQuantity(1);
        if (seat && seat.freeseats) {
          const options = Array.from(
            { length: parseInt(saverepMsg.seats_info.quantity) },
            (_, i) => ({
              text: (i + 1).toString(),
              value: i + 1,
            })
          );
          setquantityOptions(options);
        } else {
          setquantityOptions([]);
        }
        setDeleteModal(true);
      } else if (saverepMsg.delete_seat_alert) {
        setdeleteRestrictMessage(saverepMsg.delete_seat_alert);
        setModalType("restrict_delete_warning");
        setDeleteModal(true);
      } else if (saverepMsg.last_seat_del_msg) {
        setdeleteRestrictMessage(saverepMsg.last_seat_del_msg);
        setModalType("last_seat_warning");
        setDeleteModal(true);
      }
    }
  };

  const handleOK = () => {
    setDeleteModal(false);
  };

  const { fields } = useFieldArray({
    control,
    name: "available_seats",
  });

  console.log(invoice);

  useEffect(() => {
    if (availableSeats && availableSeats.length > 0) {
      // console.log(
      //   "availableSeats ::::::::::::: " + JSON.stringify(availableSeats)
      // );
      const updatedValue = availableSeats.map((assign) => ({
        ...assign,
        no_of_seats: -1,
        bgrp_id: -1,

        freeseatsList: Array.from(
          { length: assign?.freeseats },
          (_, i) => i + 1
        ), // Ensure elements are integers if needed
      }));
      // console.log("updatedValue ::::::::::::: " + JSON.stringify(updatedValue));
      setservicePlanList(updatedValue);

      setServiceObj({});
      setServiceIdList([]);
      reset((prev) => ({
        ...prev,
        available_seats: updatedValue,
      }));
    }
  }, [availableSeats]);
  useEffect(() => {
    const updateId = invoice
      ? invoice.map((loc) => ({
          billing_group_id: parseInt(loc.billing_group_id),
        }))
      : [];
    setgroupId(updateId);
  }, [invoice]);

  const handleAssignSeat = (e, serviceid, bgrpid) => {
    e.preventDefault();

    const value = parseInt(serviceid);
    const freeSeats = e.target.value;
    const grname = parseInt(bgrpid);

    console.log("values:::::::::::::::::::::::" + value);
    let freeSeatList = watch("available_seats");
    if (freeSeats != -1) {
      if (!serviceIdList.includes(value)) {
        let updatedValue = [...serviceIdList, value];

        setServiceIdList(updatedValue);
      }

      delete serviceObj[serviceid];
      let updatedObj = { ...serviceObj, [serviceid]: freeSeats ?? "" };
      setServiceObj(updatedObj);
      console.log("updated value:::::::;" + JSON.stringify(updatedObj));
      freeSeatList = freeSeatList.filter(
        (seat) => seat.service_id !== serviceid
      );
      const newValue = {
        service_id: parseInt(value),
        no_of_seats: freeSeats,
        bgrp_id: grname,
      };
      console.log("newvalue:::::::::::::::::::::::::" + newValue);
      freeSeatList = [...freeSeatList, newValue];
    } else {
      let updatedvalue = serviceIdList.filter(
        (service) => service !== serviceid
      );
      delete serviceObj[serviceid];
      setServiceIdList(updatedvalue);
      freeSeatList = freeSeatList.filter(
        (seat) => seat.service_id !== serviceid
      );
    }

    setValue(`available_seats`, freeSeatList, { shouldDirty: true });
  };

  let processRows = [];
  fields.length > 0 &&
    fields.forEach((info, index) => {
      processRows.push({
        seatsInfo: info,
        name: info.seatname,
        total: info?.totalseats ?? "",
        used: info?.usedseats ?? "",
        unused: info?.freeseats !== undefined ? info?.freeseats : "",
        assignedSeats: (
          <>
            {info?.freeseats !== 0 && invoice.length > 0 ? (
              <div className="d-flex align-items-center justify-content-center">
                <select
                  name=""
                  id=""
                  className="form-controsetAvailableSeatsl form-select"
                  value={watch(`available_seats.${index}.no_of_seats`)}
                  onChange={(e) => {
                    setValue(
                      `available_seats.${index}.no_of_seats`,
                      e.target.value,
                      { shouldDirty: true }
                    );
                    // handleAssignSeat(e, info.serviceid);
                  }}
                >
                  <option value={-1}>-- Select Seat(s) --</option>

                  {info?.freeseatsList?.map((num) => (
                    <option value={num}>{num} </option>
                  ))}
                </select>

                <select
                  name=""
                  id=""
                  className="form-control form-select ms-3"
                  value={watch(`available_seats.${index}.bgrp_id`)}
                  onChange={(e) => {
                    setValue(
                      `available_seats.${index}.bgrp_id`,
                      e.target.value,
                      { shouldDirty: true }
                    );
                    // handleAssignSeat(e, info.serviceid)
                  }}
                >
                  <option value="Credit Card">
                    -- Select Invoice Group --
                  </option>
                  {invoice &&
                    invoice.map((loc) => (
                      <option value={parseInt(loc.billing_group_id)}>
                        {loc.group_name}
                      </option>
                    ))}
                </select>
              </div>
            ) : invoice.length === 0 ? (
              <> No Invoice Group to assign.</>
            ) : (
              <>No seats to assign.</>
            )}
          </>
        ),
        remove: (
          <div className="d-flex align-items-center ms-2">
            {info?.freeseats !== undefined && info?.freeseats !== 0 && (
              <div className="d-flex align-items-center ms-2">
                <div
                  className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedSeat(info);
                    handleDeleteQuantity(info);
                  }}
                >
                  <MDBIcon
                    fas
                    icon="times"
                    color="primary"
                    className="mx-2 fs-5"
                  />
                </div>
              </div>
            )}
          </div>
        ),
      });
    });

  const actionData = {
    columns: [
      { label: "Seats", field: "name" },
      { label: "Total", field: "total" },
      { label: "Used", field: "used" },
      { label: "Unused", field: "unused" },
      {
        label: "Assign Seats to Other Billing Group",
        field: "assignedSeats",
      },
      { label: "Remove", field: "remove" },
    ],

    rows: processRows,
  };

  return (
    <>
      <div className="general-settings" id="general">
        Available Seats
      </div>
      <MDBDatatable
        pagination={false}
        data={actionData}
        className="actioncolumn"
        sortField="Billing Groups"
      />

      <MDBModal
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        tabIndex="-1"
      >
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle className="fw-bold">
                Remove Unused Seat(s)
              </MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={() => setDeleteModal(false)}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {modalType === "last_seat_warning" ||
              modalType === "restrict_delete_warning" ? (
                <div className="mb-3">
                  <p className="mb-3">
                    {deleteRestrictMessage}
                    {/* You cannot delete the seat(s), as there must be at least one
                    seat in your account. Deleting all seats in the account does
                    not delete the account. Please contact Support for more
                    details. */}
                  </p>
                </div>
              ) : modalType === "acd_warning" ? (
                <div className="mb-3">
                  <p className="mb-3">
                    This is the last seat that supports ACD feature in your
                    account. Deleting this seat will automatically delete all
                    ACD queues and ACD related features.
                  </p>
                  <p>Are you sure, you want to Delete?</p>
                </div>
              ) : (
                <div className="mb-3">
                  <div className="mb-2">
                    Billing Group: <strong>{bgroupName || "N/A"}</strong>
                  </div>
                  <div className="mb-3">
                    Service Name:{" "}
                    <strong>{selectedSeat?.seatname || "N/A"}</strong>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Quantity:</span>
                    <select
                      className="form-select form-select-sm w-auto"
                      value={quantity}
                      onChange={(e) => setQuantity(parseInt(e.target.value))}
                    >
                      {quantityOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.text}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </MDBModalBody>
            <MDBModalFooter>
              {modalType === "last_seat_warning" ||
              modalType === "restrict_delete_warning" ? (
                <MDBBtn color="primary" onClick={handleOK}>
                  OK
                </MDBBtn>
              ) : (
                <>
                  <MDBBtn
                    color="secondary"
                    onClick={() => setDeleteModal(false)}
                  >
                    Cancel
                  </MDBBtn>
                  <MDBBtn
                    color="danger"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDelete(1);
                    }}
                  >
                    Remove
                  </MDBBtn>
                </>
              )}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
